module.exports = __webpack_public_path__ + "static/shipwreck-ext-7b4bad07ce93a623140a0ab09a9e7e91.jpg";